/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'Communication/Contact': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" fill-rule="evenodd" d="M23.84 23.758l-1.092 1.09a.502.502 0 01-.709 0l-3.19-3.19.73-.724c.453-.428 1.212-1.145 1.226-2.139.006-.384-.105-.956-.66-1.512l-5.429-5.429c-.555-.554-1.128-.664-1.51-.658-.995.013-1.712.772-2.14 1.225l-.725.73-3.19-3.19a.502.502 0 010-.71L8.215 8.19c.07-.076 1.105-1.155 2.947-1.183 1.933-.03 4.042 1.083 6.268 3.31l4.255 4.253c2.226 2.227 3.34 4.335 3.309 6.27-.027 1.84-1.107 2.874-1.153 2.919m-.738-10.606l-4.254-4.254c-2.648-2.647-5.265-3.958-7.78-3.896-2.702.066-4.243 1.733-4.306 1.804l-1.03 1.028a2.508 2.508 0 000 3.544l3.368 3.368a1.756 1.756 0 002.48 0l.942-.948c.143-.152.517-.547.701-.595.004.009.033.028.075.07l5.428 5.428c.063.064.078.097.079.098-.033.137-.448.53-.605.678l-.947.941a1.757 1.757 0 000 2.481l3.367 3.368a2.508 2.508 0 003.545 0l1.063-1.065c.035-.029 1.703-1.57 1.769-4.27.062-2.516-1.25-5.134-3.895-7.78"/>'
  }
})
